// extracted by mini-css-extract-plugin
export default {"new-page-loader":"new-page-loader--G82BC","spirito-icon":"spirito-icon--1BT2H","loading-text":"loading-text--3xOSA"};